import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';
import { TableCertificationFragmentGql } from './TableCertificationFragmentGql';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';

export const TableFragmentGql: DocumentNode = gql`
fragment TableFragment on Table {
  id
  name
  description
  isEmbedded
  ... on DatabaseTable {
    fullName
    luid
    vizportalId
    description
    ...TableCertificationFragment
    contact {
      ...TableauUserFragment
    }
    dataQualityWarnings {
      ...DataQualityWarningFragment
    }
    database {
      id
      name
      connectionType
      isCertified
      ... on DatabaseServer {
        hostName
        port
      }
      ... on CloudFile {
        fileId
        provider
      }
      ... on File {
        filePath
      }
      ... on WebDataConnector {
        connectorUrl
      }
    }
  }
}
${DataQualityWarningFragmentGql}
${TableCertificationFragmentGql}
${TableauUserFragmentGql}
`;
